import React, { useContext, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// ? - super_admin
const useForm = (optionsToDisplay, fetcher) => {
    const { editAction, deleteAction } = optionsToDisplay;

    const history = useHistory();
    const { t } = useTranslation();
    const getEstablishmentByRegion = (query) => AxiosInstance.get('/establishment', { params: {...query } });

    const updateContract = (id) => {
        history.push({
            pathname: '/contract/update',
            params: {
                id: id,
            },
        });
    };

    const downloadContractFile = (contract) => {
        history.push({
            pathname: '/invoice',
            params: {
                contract: contract,
            },
        });
    };

    const deleteContract = (id) => {
        Swal.fire({
            title: t('swal.are_you_sure'),
            text: t('swal.delete_permanently'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('swal.yes_delete'),
            cancelButtonText: t('swal.no'),
        }).then((result) => {
            if (result.isConfirmed) {
                AxiosInstance.delete('/contract/' + id)
                    .then((response) => {
                        Swal.fire(t('contract.SUCCESS_DELETE_CONTRACT'), '', 'success');
                        fetcher();
                    })
                    .catch((error) => {
                        Swal.fire(t('contract.ERROR_DELETE_CONTRACT'), '', 'error');
                    });
            }
        });
    };

    const attributes = [{ name: 'name', title: t('table.establishment'), nestedObject: [], type: 'text', order: true }];

    const actions = {
        delete: deleteAction && deleteContract,
        update: editAction && updateContract,
        downloadContractFile: downloadContractFile,
    };

    return {
        attributes,
        actions,
        getEstablishmentByRegion,
    };
};

export function useEstablishmentUserForm(optionsToDisplay, userEstablishmentId) {
    const { addButton, editAction, deleteAction } = optionsToDisplay;
    // const {} = useContext()
    const [userEstablishment, setUserEstablishment] = useState(null);
    const [listContract, setListContract] = useState([]);
    const [totalItems, setTotalItems] = useState(null);
    const [totalPages, setTotalPages] = useState(null);
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [query, setQuery] = useState({ page: null, order: 'status DESC', keyword: '', limit: 10 });

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const page = parseInt(queryParams.get('page'));
        const order = queryParams.get('order');
        const keyword = queryParams.get('keyword');
        setQuery((prev) => ({
            ...prev,
            page: page ? page - 1 : 0,
            order: order ? order : query.order,
            keyword: keyword ? keyword : '',
        }));
    }, [location]);

    useEffect(() => {
        if (query.page !== null) {
            findAllContract();
        }
    }, [query]);

    const findAllContract = () => {
        setLoading(true);

        AxiosInstance.get('/contract', { params: query })
            .then((response) => {
                setListContract(response.data.items);
                setTotalPages(response.data.totalPages);
                setTotalItems(response.data.totalItems);
                setLoading(false);
            })
            .catch((error) => {
                Swal.fire(t('contract.ERROR_GET_CONTRACTS'), '', 'error');
                setLoading(false);
            });
    };

    const updateContract = (id) => {
        history.push({
            pathname: '/contract/update',
            params: {
                id: id,
            },
        });
    };

    const downloadContractFile = (contract) => {
        history.push({
            pathname: '/invoice',
            params: {
                contract: contract,
            },
        });
    };

    const deleteContract = (id) => {
        Swal.fire({
            title: t('swal.are_you_sure'),
            text: t('swal.delete_permanently'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('swal.yes_delete'),
            cancelButtonText: t('swal.no'),
        }).then((result) => {
            if (result.isConfirmed) {
                AxiosInstance.delete('/contract/' + id)
                    .then((response) => {
                        Swal.fire(t('contract.SUCCESS_DELETE_CONTRACT'), '', 'success');
                        findAllContract();
                    })
                    .catch((error) => {
                        Swal.fire(t('contract.ERROR_DELETE_CONTRACT'), '', 'error');
                    });
            }
        });
    };

    const attributes = [
        { name: 'name', title: t('table.establishment'), nestedObject: ['establishment'], type: 'text', order: true },
        { name: 'status', title: t('table.status'), nestedObject: [], type: 'switcherContract', order: true, active: editAction },
        { name: 'contractStartDate', title: t('table.contractStartDate'), nestedObject: [], type: 'date', order: true },
        { name: 'contractEndDate', title: t('table.contractEndDate'), nestedObject: [], type: 'date', order: true },
    ];

    const actions = {
        delete: deleteAction && deleteContract,
        update: editAction && updateContract,
        downloadContractFile: downloadContractFile,
    };

    return {
        attributes,
        actions,
        listContract,
        findAllContract,
        totalPages,
        query,
        loading,
    };
}

export default useForm;